import React from 'react';
export function SiteFooter() {
  return <footer className="bg-canvas py-14" style={{
    paddingTop: "17px",
    paddingBottom: "17px"
  }} data-id="element-86" data-mp="1dr1f9lwgpvek">
      <div className="mx-auto max-w-7xl px-6" data-id="element-87" data-mp="3r918yjclor6p">
        

        <p className="mt-10 text-center text-sm text-prose" style={{
        marginTop: "17px",
        marginBottom: "17px"
      }} data-id="element-88" data-mp="3mgrdknspuyx1">
          Fragen?{' '}
          <a href="mailto:support@urbanfarmingsystem2026.de" className="font-medium text-emerald underline underline-offset-4 transition-colors duration-150 ease-out hover:text-forest" data-id="element-89" data-mp="3hglrdn57u4mc">
            aulanova.digital@gmail.com
          </a>
        </p>
      </div>
    </footer>;
}